import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import {
  ContentCollectionEntryType,
  ContentCollectionsEntriesState,
  ContentCollectionType,
} from 'b2b-apps/shop/content/redux/contentCollectionsEntries/types';

const getState = (state: State): ContentCollectionsEntriesState => state.content.contentCollectionsEntries;

const getCollections = (state: State): ContentCollectionsEntriesState => getState(state) || {};

const getCollectionById = (
  state: State,
  collectionId: string,
): ContentCollectionType | undefined => getCollections(state)[collectionId];

const getCollectionEntryByIds = (
  state: State,
  collectionId: string,
  entryId: string,
): RemoteRecord<ContentCollectionEntryType> => {
  const collection = getCollectionById(state, collectionId);

  if (collection && Object.hasOwnProperty.call(collection, entryId)) {
    return new RemoteRecord(collection[entryId]);
  }

  return new RemoteRecord(undefined);
};

export { getCollectionById, getCollectionEntryByIds, getCollections, getState };
